/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type AccountIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountIdentityQuery = { viewer: { customer: { id: Types.Scalars['ID']['output'], isAgent: Types.Scalars['Boolean']['output'] } | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const AccountIdentityDocument = /*#__PURE__*/ new TypedDocumentString(`
    query AccountIdentity {
  viewer {
    customer {
      id
      isAgent
    }
  }
}
    `) as unknown as TypedDocumentString<AccountIdentityQuery, AccountIdentityQueryVariables>;